import { FormikProps } from 'formik'

import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

import { CustomTimeRangesFormData } from 'modules/attendance/lib/forms/utils/CustomTimeRangesFormData'
import { ContractTaxonomy } from 'modules/contracts/hooks/useFetchContractsTaxonomies'
import { ReimbursableSupplementTaxonomyMapping } from 'modules/payroll_bundle/hooks/useFetchReimbursableSupplementMappings'

import { manageMapping } from './utils/manageMappping'

interface Props {
  timeRangeCategoryId: string
  legalEntityId: string
  taxonomies: ContractTaxonomy[]
  mapping: ReimbursableSupplementTaxonomyMapping | undefined
  form: FormikProps<CustomTimeRangesFormData>
}

const TimeMappingDropdown = ({
  timeRangeCategoryId,
  legalEntityId,
  taxonomies,
  mapping,
  form,
}: Props) => {
  const onChange = (taxonomyId: string) => {
    const updatedMappings = manageMapping({
      taxonomyId,
      mappingId: mapping?.id,
      timeRangeCategoryId,
      legalEntityId,
      formMappings: form.values.reimbursable_taxonomies_mappings || [],
    })
    form.setFieldValue('reimbursable_taxonomies_mappings', updatedMappings)
  }

  const options = taxonomies.map((taxonomy) => ({
    label: taxonomy.name,
    value: taxonomy.id,
  }))

  const persistedValue = mapping?.supplementTaxonomyId
  const selectedValue = form.values.reimbursable_taxonomies_mappings?.find(
    (mapping) => mapping.legalEntityId === legalEntityId.toString()
  )?.supplementTaxonomyId
  const renderedValue = selectedValue || persistedValue

  return (
    <SelectField
      options={options}
      none={
        !persistedValue
          ? i18n.t('time_tracking.settings.time_blocks.categories.modals.select')
          : undefined
      }
      onChange={onChange}
      value={renderedValue}
    />
  )
}

export default TimeMappingDropdown
